// common/features/social/helpers/buildPostShareUrl.ts

export type PostShareEntityType = 'organization' | 'team' | 'schedule'

export interface BuildPostShareUrlArgs {
  origin: string
  postId?: string | null
  entityType?: PostShareEntityType | null
  entityId?: string | null
  isAppPost?: boolean
}

const ENTITY_PREFIX: Record<PostShareEntityType, string> = {
  organization: 'org',
  team: 'team',
  schedule: 'schedule',
}

export const buildPostShareUrl = ({
  origin,
  postId,
  entityType,
  entityId,
  isAppPost,
}: BuildPostShareUrlArgs): string | null => {
  if (!postId) {
    return null
  }

  const homeFeedUrl = `${origin}/home/feed/${postId}`

  if (isAppPost) {
    return homeFeedUrl
  }

  if (!entityType || !entityId) {
    return homeFeedUrl
  }

  const prefix = ENTITY_PREFIX[entityType]

  return `${origin}/${prefix}/${entityId}/feed/${postId}`
}
